var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _ellipse, _ellipse2, _path3, _rect11, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnterprisePlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 109,
    viewBox: "0 0 171 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 1.5,
    width: 141,
    height: 106,
    rx: 7.5,
    fill: "white",
    stroke: "#EFF5FA",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9C17.5 4.85787 20.8579 1.5 25 1.5H53.5V107.5H25C20.8579 107.5 17.5 104.142 17.5 100V9Z",
    fill: "white",
    stroke: "#EFF5FA",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9C17.5 4.85786 20.8579 1.5 25 1.5H151C155.142 1.5 158.5 4.85786 158.5 9V31.5H17.5V9Z",
    fill: "white",
    stroke: "#EFF5FA",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 42,
    width: 21,
    height: 4,
    rx: 1,
    fill: "#EFF5FA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 50,
    width: 21,
    height: 4,
    rx: 1,
    fill: "#EFF5FA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 58,
    width: 21,
    height: 4,
    rx: 1,
    fill: "#EFF5FA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 66,
    width: 16,
    height: 4,
    rx: 1,
    fill: "#EFF5FA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 41,
    width: 78,
    height: 6,
    rx: 1,
    fill: "#C6E3FD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 63,
    width: 78,
    height: 6,
    rx: 1,
    fill: "#FCB4CE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 74,
    width: 78,
    height: 6,
    rx: 1,
    fill: "#C6E3FD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 85,
    width: 57,
    height: 6,
    rx: 1,
    fill: "#B2EBEB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 52,
    width: 78,
    height: 6,
    rx: 1,
    fill: "#B2EBEB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142,
    cy: 16.5,
    rx: 8,
    ry: 8.5,
    fill: "#CAE6FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142,
    cy: 13.78,
    rx: 2.88,
    ry: 3.06,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.133 22.2787C136.836 19.5364 139.196 17.52 142 17.52C144.804 17.52 147.164 19.5363 147.867 22.2786C146.406 23.9525 144.318 25 142 25C139.682 25 137.594 23.9525 136.133 22.2787Z",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 14,
    width: 68,
    height: 5,
    rx: 1,
    fill: "#EBF5FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 25H33.5L33.4986 21.6019L42 8H25V25Z",
    fill: "#5CCEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 25H32.4643L28.8888 19.2343L34.94 13.6666L42 25Z",
    fill: "#4D94FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8474 12.25H33.6755C34.5307 12.25 35.3509 12.5897 35.9556 13.1944C36.5603 13.7992 36.9 14.6193 36.9 15.4745V20.3026C36.9 20.5497 36.6997 20.75 36.4527 20.75H31.6246C30.7694 20.75 29.9492 20.4103 29.3445 19.8056C28.7398 19.2008 28.4 18.3807 28.4 17.5255V12.6974C28.4 12.4503 28.6003 12.25 28.8474 12.25Z",
    fill: "#F7F7F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.525 13.95H34.775V15.1886H33.3461V19.05H31.9539V15.1886H30.525V13.95Z",
    fill: "#4D94FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2186 60.4907C18.9608 59.0362 21.0392 59.0362 21.7814 60.4907L25.5329 67.8418C25.8235 68.4112 26.3688 68.8074 27.0002 68.9078L35.1508 70.2041C36.7635 70.4606 37.4057 72.4372 36.2518 73.5926L30.4198 79.4321C29.968 79.8844 29.7597 80.5255 29.8593 81.157L31.1451 89.3092C31.3995 90.9222 29.7182 92.1438 28.2627 91.4034L20.9068 87.6613C20.337 87.3715 19.663 87.3715 19.0932 87.6613L11.7373 91.4034C10.2818 92.1438 8.60046 90.9222 8.85488 89.3092L10.1407 81.157C10.2403 80.5255 10.032 79.8844 9.58025 79.4321L3.74825 73.5926C2.59432 72.4372 3.23654 70.4606 4.84923 70.2041L12.9998 68.9078C13.6312 68.8074 14.1765 68.4112 14.4671 67.8418L18.2186 60.4907Z",
    fill: "url(#paint0_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.219 22.4907C151.961 21.0362 154.039 21.0362 154.781 22.4907L157.933 28.667C158.224 29.2364 158.769 29.6326 159.401 29.733L166.249 30.8221C167.861 31.0786 168.504 33.0552 167.35 34.2106L162.45 39.1169C161.998 39.5692 161.79 40.2103 161.889 40.8418L162.97 47.6912C163.224 49.3042 161.543 50.5258 160.087 49.7854L153.907 46.6413C153.337 46.3515 152.663 46.3515 152.093 46.6413L145.913 49.7854C144.457 50.5258 142.776 49.3042 143.03 47.6912L144.111 40.8418C144.21 40.2103 144.002 39.5692 143.55 39.1169L138.65 34.2106C137.496 33.0552 138.139 31.0786 139.751 30.8221L146.599 29.733C147.231 29.6326 147.776 29.2364 148.067 28.667L151.219 22.4907Z",
    fill: "url(#paint1_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2186 83.4907C45.9609 82.0362 48.0391 82.0362 48.7814 83.4907L50.1348 86.1426C50.4254 86.712 50.9707 87.1082 51.6021 87.2086L54.5423 87.6762C56.155 87.9327 56.7972 89.9093 55.6433 91.0647L53.5394 93.1713C53.0877 93.6236 52.8794 94.2647 52.979 94.8962L53.4428 97.8371C53.6973 99.4501 52.0159 100.672 50.5604 99.9312L47.9068 98.5813C47.337 98.2915 46.663 98.2915 46.0932 98.5813L43.4396 99.9313C41.9841 100.672 40.3027 99.4501 40.5572 97.8371L41.021 94.8962C41.1206 94.2647 40.9123 93.6236 40.4606 93.1713L38.3567 91.0647C37.2028 89.9093 37.845 87.9327 39.4577 87.6762L42.3979 87.2086C43.0293 87.1082 43.5746 86.712 43.8652 86.1426L45.2186 83.4907Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20,
    y1: 57,
    x2: 20,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6184FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F53CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 153,
    y1: 19,
    x2: 153,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6184FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F53CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 47,
    y1: 80,
    x2: 47,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6184FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F53CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprisePlan);
export default __webpack_public_path__ + "static/media/enterprise-plan.92810b3c256c564202b55addcff0c9c4.svg";
export { ForwardRef as ReactComponent };